import { Reveal } from './hareket'
import { ButonHref, ButonLink, Container, DEMO_YOLU, PANEL_URL } from './ui'

export function SonCta({
  baslik = 'Derneğinizi bir öğleden sonra taşıyın.',
  metin = 'On dört gün deneme, kart bilgisi yok. Üye listenizi Excel’den aktarın, ödeme sağlayıcınızı bağlayın; gerisi kendiliğinden işler.',
}: {
  baslik?: string
  metin?: string
}) {
  return (
    <section className="px-5 pb-16 sm:px-8 sm:pb-24">
      <Container>
        <Reveal>
          <div className="relative overflow-hidden rounded-[var(--radius-panel)] bg-brand px-6 py-14 text-on-brand sm:px-14 sm:py-20">
            <div
              className="pointer-events-none absolute inset-0 opacity-[0.12]"
              style={{
                backgroundImage:
                  'linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)',
                backgroundSize: '40px 40px',
                maskImage:
                  'radial-gradient(ellipse 80% 80% at 80% 50%, #000 20%, transparent 100%)',
              }}
              aria-hidden
            />
            <div className="relative grid gap-8 md:grid-cols-[1.4fr_1fr] md:items-center">
              <div>
                <h2 className="display text-3xl sm:text-4xl">{baslik}</h2>
                <p className="mt-4 max-w-xl text-pretty text-base leading-relaxed opacity-90">
                  {metin}
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row md:flex-col md:items-stretch">
                <ButonLink to={DEMO_YOLU} variant="light" size="lg" ok>
                  Demo isteyin
                </ButonLink>
                <ButonHref
                  href={PANEL_URL}
                  variant="ghost"
                  size="lg"
                  className="text-on-brand hover:bg-on-brand/10 hover:text-on-brand"
                >
                  Panele giriş
                </ButonHref>
              </div>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  )
}
